import { Delete as TrashIcon, Search as SearchIcon } from '@mui/icons-material';
import { GlobalButtonVariant } from '@/components/buttons/GlobalButton';
import { GlobalButton, SelectInput } from '@/components';
import { useState } from 'react';

import {
  ACTIVE_STATUS_FILTER,
  ALL_STATUS_FILTER,
  DEFAULT_INTEGRATION_REQUEST_FILTERS,
  INTEGRATION_REQUEST_STATUS_LABELS,
  INTEGRATION_REQUEST_TYPE_LABELS,
  IntegrationRequestStatus,
  type IntegrationRequestFilters,
  type IntegrationRequestType,
} from '../../../../models/IntegrationRequest';

const statusOptions = [
  { value: ACTIVE_STATUS_FILTER, label: 'Abiertas' },
  { value: ALL_STATUS_FILTER, label: 'Todas' },
  ...Object.values(IntegrationRequestStatus).map((status) => ({
    value: status,
    label: INTEGRATION_REQUEST_STATUS_LABELS[status],
  })),
];

const typeOptions = [
  { value: '', label: 'Todos los tipos' },
  ...(Object.keys(INTEGRATION_REQUEST_TYPE_LABELS) as IntegrationRequestType[]).map((type) => ({
    value: type,
    label: INTEGRATION_REQUEST_TYPE_LABELS[type],
  })),
];

interface IntegrationRequestsSearchBarProps {
  filters: IntegrationRequestFilters;
  onSearch: (filters: IntegrationRequestFilters) => void;
}

const IntegrationRequestsSearchBar = ({ filters, onSearch }: IntegrationRequestsSearchBarProps) => {
  const [localFilters, setLocalFilters] = useState<IntegrationRequestFilters>(filters);

  const reset = () => {
    setLocalFilters(DEFAULT_INTEGRATION_REQUEST_FILTERS);
    onSearch(DEFAULT_INTEGRATION_REQUEST_FILTERS);
  };

  return (
    <div className='w-full p-5 bg-white rounded-lg shadow-md'>
      <div className='flex flex-col gap-4'>
        <h2 className='text-lg font-semibold text-gray-800'>Filtros de búsqueda</h2>
        <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-2.5'>
          <SelectInput
            name='integration-request-status'
            placeholder='Estado'
            value={localFilters.status}
            onChange={(value: string) => setLocalFilters((prev) => ({ ...prev, status: value }))}
            options={statusOptions}
          />
          <SelectInput
            name='integration-request-type'
            placeholder='Tipo'
            value={localFilters.type}
            onChange={(value: string) =>
              setLocalFilters((prev) => ({ ...prev, type: value as IntegrationRequestType | '' }))
            }
            options={typeOptions}
          />
        </div>
        <div className='flex gap-2 justify-end'>
          <GlobalButton variant={GlobalButtonVariant.secondaryButton} action={reset}>
            <TrashIcon />
            Limpiar
          </GlobalButton>
          <GlobalButton
            variant={GlobalButtonVariant.primaryButton}
            action={() => onSearch(localFilters)}
          >
            <SearchIcon />
            Buscar
          </GlobalButton>
        </div>
      </div>
    </div>
  );
};

export default IntegrationRequestsSearchBar;
